<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top border-bottom navbar-expand"
    :class="{ 'bg-orange navbar-dark': type === 'default' }"
  >
    <!-- Navbar links -->
    <ul class="navbar-nav align-items-center">
      <li class="nav-item d-xl-none">
        <!-- Sidenav toggler -->
        <div
          class="pr-3 sidenav-toggler"
          :class="{
            active: $sidebar.showSidebar,
            'sidenav-toggler-dark': type === 'default',
            'sidenav-toggler-light': type === 'light'
          }"
          @click="toggleSidebar"
        >
          <div class="sidenav-toggler-inner">
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
          </div>
        </div>
      </li>
    </ul>
    <div class="ml-auto">
      <base-dropdown hasToggle menuOnRight>
        <div slot="title-container" type="primary">
          <a
            class="nav-link pr-0"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <div class="media align-items-center">
              <span class="avatar avatar-sm rounded-circle">
                <img
                  class="bg-white"
                  alt="Image placeholder"
                  :src="userAvatar"
                  onerror="this.src='https://www.chinesepod.com/home/img/brand/symbol-black-center.svg'"
                />
              </span>
              <div class="media-body ml-2">
                <span
                  class="mb-0 text-sm font-weight-bold"
                  :class="type === 'default' ? 'text-white' : ''"
                  >{{ userName }}</span
                >
              </div>
            </div>
          </a>
        </div>
        <div class="dropdown-header noti-title">
          <h6 class="text-overflow m-0">Welcome!</h6>
        </div>
        <a href="/profile" class="dropdown-item">
          <i class="ni ni-single-02"></i>
          <span>Your Profile</span>
        </a>
        <a href="/settings" class="dropdown-item">
          <i class="ni ni-settings-gear-65"></i>
          <span>Settings</span>
        </a>
        <a href="https://support.chinesepod.com/" class="dropdown-item">
          <i class="ni ni-support-16"></i>
          <span>Support</span>
        </a>
        <div class="dropdown-divider"></div>
        <a @click="logout()" class="dropdown-item">
          <i class="ni ni-user-run"></i>
          <span>Log out</span>
        </a>
      </base-dropdown>
    </div>
  </base-nav>
</template>
<script>
import { BaseNav, BaseDropdown } from '@/components'

import { mapGetters } from 'vuex'

import pickBy from 'lodash.pickby'

export default {
  components: {
    // CollapseTransition,
    BaseNav,
    BaseDropdown
    // Modal
  },
  props: {
    type: {
      type: String,
      default: 'default', // default|light
      description:
        'Look of the dashboard navbar. Default (Green) or light (gray)'
    }
  },
  computed: {
    routeName() {
      const { name } = this.$route
      return this.capitalizeFirstLetter(name)
    },
    userAvatar() {
      return this.$store.state.userInfo
        ? this.$store.state.userInfo.userAvatar
        : ''
    },
    userName() {
      return this.$store.state.userInfo ? this.$store.state.userInfo.email : ''
    }
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      showToolbar: false
    }
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    closeDropDown() {
      this.activeNotifications = false
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    async logout() {
      await this.$store.dispatch('logout')
      this.$store.commit('affiliates/RESET_AFFILIATE_INFO')
      await this.$router.push({ name: 'Log In' })
    }
  }
}
</script>

<style lang="scss">
$cpod-any: #0f4bbd !default;
$cpod-newbie: #2487c1 !default;
$cpod-elementary: #35c567 !default;
$cpod-preint: #f7b500 !default;
$cpod-intermediate: #ff4d0f !default;
$cpod-upperint: #e1001e !default;
$cpod-advanced: #89006b !default;
$cpod-media: #003041 !default;

.navbar-top {
  .bg-newbie,
  .bg-elementary,
  .bg-preint,
  .bg-intermediate,
  .bg-upperint,
  .bg-advanced {
    width: 25px;

    div {
      margin-left: 4px;
    }
  }
}

.search-popover {
  /*font-size: larger !important;*/
  color: white !important;
  margin-top: 3px !important;
  padding: 0 !important;
  border: none !important;
  /*box-shadow: none !important;*/
  -webkit-box-shadow: 0 0.75rem 1rem 0.25rem rgba(136, 152, 170, 0.25) !important;
  box-shadow: 0 0.75rem 1rem 0.25rem rgba(136, 152, 170, 0.25) !important;
}

.row-1-box-1 {
  background-color: $cpod-newbie;
  width: 250px;
}
.row-1-box-2 {
  background-color: $cpod-elementary;
  width: 25px;
}
.row-1-box-3 {
  background-color: $cpod-preint;
  width: 25px;
}
.row-1-box-4 {
  background-color: $cpod-intermediate;
  width: 25px;
}
.row-1-box-5 {
  background-color: $cpod-upperint;
  width: 25px;
}
.row-1-box-6 {
  background-color: $cpod-advanced;
  width: 250px;
}
.row-2-box-1 {
  background-color: $cpod-elementary;
  width: 275px;
}
.row-2-box-2 {
  background-color: $cpod-preint;
  width: 25px;
}
.row-2-box-3 {
  background-color: $cpod-intermediate;
  width: 25px;
}
.row-2-box-4 {
  background-color: $cpod-upperint;
  width: 275px;
}
.row-3-box-1 {
  background-color: $cpod-preint;
  width: 300px;
}
.row-3-box-2 {
  background-color: $cpod-intermediate;
  width: 300px;
}
.toolbar-text {
  font-size: large;
  /*text-align: center;*/
  font-weight: bold;
}
.row-1-box-6,
.row-2-box-4,
.row-3-box-2 {
  text-align: right;
}
</style>
